export default __webpack_public_path__ + "static/media/taali.c4221b0e.png";